import { fromJS } from 'immutable'
import {
  REPORT_COMPENSATE_GET_REQUEST,
  REPORT_COMPENSATE_GET_SUCCESS,
  REPORT_HEADCOUNT_GET_FAILURE,
  REPORT_COMPENSATE_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case REPORT_COMPENSATE_GET_REQUEST:
      return state
        .set('isFetching', true)
    case REPORT_COMPENSATE_GET_SUCCESS:
      return state
        .set('isFetching', false)
        .set('compensateReport', fromJS(action.payload))
    case REPORT_HEADCOUNT_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case REPORT_COMPENSATE_GET_RESET:
      return state
        .delete('compensateReport')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/report/report-compensate-get-reducer.js